import { Directive, ElementRef, NgModule, Renderer2, Input } from "@angular/core";

@Directive({
   selector: '[remove-wrapper]'
})
export class RemoveWrapperDirective {
  constructor(private elRef: ElementRef, private renderer: Renderer2) { }

  ngAfterViewInit(): void {

    // access the DOM. get the element to unwrap
    const el = this.elRef.nativeElement;
    const parent = this.renderer.parentNode(this.elRef.nativeElement);
    // move all children out of the element
    while (el.firstChild) { // this line doesn't work with server-rendering
      this.renderer.insertBefore(parent, el.firstChild, el);
    }

    // remove the empty element from parent
    this.renderer.removeChild(parent, el);
  }
}

@Directive({ selector: '[indeterminate]' })
export class IndeterminateDirective {
  @Input()
  set indeterminate(value: boolean) {
    this.elem.nativeElement.indeterminate = value;
  }
  constructor(private elem: ElementRef) {
  }
}

@NgModule({
  imports: [],
  declarations: [
    RemoveWrapperDirective,
    IndeterminateDirective,
  ],
  exports: [
    RemoveWrapperDirective,
    IndeterminateDirective,
  ]
})
export class UtilitiesDirectivesModule {
}
